/*!
 * @license Ranj B.V.
 * Copyright (c) 2020 Ranj B.V. all rights reserved 
 */

 //Vendors
import 'soma.js';
import 'createjs';

//Styles
import './css/style.css';
import './css/fonts.css';

import App from './ranj/app/core/App';

//NB: I changed the TextLayout import to the project specific version. The TextLayout approach needs to be changed, so we can configure it in project.
import TextLayout from './ranj/app/ui/TextLayout';

window.ranj = { DEBUG: DEFINE.DEBUG }; // for backwards compatibility (e.g. ranj.DEBUG)

function init() {
    ranj.TextLayout = TextLayout;//place in global scope so skin files can access the TextLayout module

    const app = new App();
    if (ranj.DEBUG) {
        //Expose app instance globally for debugging
        ranj.app = app;
    }
}

init();